const observer = new MutationObserver(() => {
    document.querySelectorAll('.wc-block-components-radio-control__option').forEach(option => {

        if (
            option.textContent.includes('Local pickup') &&
            !option.querySelector('.pickup-address')
        ) {
            option.insertAdjacentHTML(
                'beforeend',
                `<small class="pickup-address">${window.ThemeConfig?.pickupAddress ?? ''}</small>`
            );
        }
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
});